import { parseDomain } from '../../utils';
import { dynamicLoadApiClient } from './dynamicLoadApiQueries';
export const queryInitialDomainContacts = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    DomainsApiClient
  } = await dynamicLoadApiClient();
  const {
    domainPurchaseData
  } = DomainsApiClient.queries({
    httpClient
  });
  const domain = parseDomain(request.domainName);
  const {
    data: purchaseData
  } = await domainPurchaseData({
    domainName: domain.asciiDomain,
    isRenewal: false
  });
  return {
    initialContacts: parseContactInfo(purchaseData.domainContacts),
    purchaseId: purchaseData.purchaseId
  };
};
export const parseContactInfo = oldPurchaseDataContacts => {
  const contactInfo = ['firstName', 'lastName', 'email', 'company', 'streetAddress', 'city', 'state', 'postalCode', 'countryCode', 'phone', 'language'].reduce((acc, key) => {
    const oldValue = oldPurchaseDataContacts['registrant' + key.charAt(0).toUpperCase() + key.slice(1)];
    if (oldValue) {
      acc[key] = oldValue;
    }
    return acc;
  }, {});
  return {
    registrant: contactInfo,
    admin: contactInfo,
    tech: contactInfo
  };
};
//# sourceMappingURL=domainContacts.js.map